import React from 'react';
import PropTypes from 'prop-types';
import Label from '../label/label';
import formatDate from 'zengenti-forms-package/utils/format-date';

const SingleDate = ({
  className,
  type,
  id,
  label,
  validations,
  setValue,
  formId,
}) => {
  const isRequired = validations && validations.required ? true : false;
  const onlyPassedDates = validations && validations.pastDateTime;

  const d = new Date();
  const todaysDate = d.toISOString();

  const _handleChange = (formId, id, value) => {
    const d = new Date(value);
    const isoDate = d.toISOString();
    setValue(formId, id, isoDate);
  };
  return (
    <div className="date-container">
      <Label
        id={id}
        label={label}
        isRequired={isRequired}
        className="label-date"
      />
      <input
        type={type}
        id={id}
        name={id}
        className={`${className ? className : ''} input-date`}
        max={onlyPassedDates ? formatDate(todaysDate, 'yyyy-MM-dd') : ''}
        onChange={e => _handleChange(formId, id, e.target.value)}
      />
    </div>
  );
};

SingleDate.propTypes = {
  className: PropTypes.string,
  formId: PropTypes.string,
  setValue: PropTypes.func,
  type: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  validations: PropTypes.object,
};

export default SingleDate;
